import { computed, reactive, ref } from '@nuxtjs/composition-api'
import deviceAndSubscriptionFlowHandler from '~/composable/checkout/handler/deviceAndSubscriptionFlowHandler';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomerInfo from '~/composable/checkout/useCustomerInfo';
import { SIM_CARD_TYPE, SECRET_NUMBER_TYPE, INITIATE_NP, CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow';
import useConfirmationInfo from '~/composable/checkout/useConfirmationInfo';
import usePaymentInfo from '~/composable/checkout/usePaymentInfo';

// checkout flow context for Mobile Voice
export default (appContext) => {
  // panel 2 - subscription
  const subscription = (() => {
    const menu = ref(null)

    const newNumber = reactive({
      mobileNumber: '',
      valid: true,
      numberSelected: {},
      secretNumber: {
        selected: false,
        radioGroup: SECRET_NUMBER_TYPE.SECRET_NONE
      },
      simTypeRadioGroup: SIM_CARD_TYPE.PHYSICAL_SIM // default selected radio button
    })

    const moveNumber = reactive({
      formValid: false,
      valid: true,
      numberValid: false,
      mobileNumber: '',
      simcardNumber: '',
      secretNumber: {
        selected: false,
        radioGroup: SECRET_NUMBER_TYPE.SECRET_NONE
      },
      simTypeRadioGroup: SIM_CARD_TYPE.PHYSICAL_SIM, // default selected radio button
      registerSimLater: false,
      initiateNpASAP: INITIATE_NP.WHEN_BINDING_EXPIRES, // default selected radio button
      cpsCode: '',
      accepted: false
    })

    const changeSubscription = reactive({
      valid: true,
      number: '',
      isUpgrade: null,
      subscriptions: null,
      prepaidAccountId: null,
      serviceAccountId: null,
      bundleName: ''
    })

    return {
      moveNumber,
      newNumber,
      changeSubscription,
      menu
    }
  })()

  const numberInfo = computed(() => {
    if (subscription?.menu?.value === CUSTOMER_SUBSCRIPTION_TYPE.NEW_NUMBER) {
      // @ts-ignore
      const mobileNumber = subscription.newNumber.numberSelected.phoneNumber
      return {
        np: false,
        mobileNumber,
        simcardType: subscription.newNumber.simTypeRadioGroup,
        secretNumber: subscription.newNumber.secretNumber.selected,
        secretInfoType: subscription.newNumber.secretNumber.radioGroup
      }
    } else if (subscription?.menu?.value === CUSTOMER_SUBSCRIPTION_TYPE.MOVE_NUMBER) {
      return {
        np: true,
        mobileNumber: subscription.moveNumber.mobileNumber,
        simcardNumber: subscription.moveNumber.simcardNumber,
        simcardType: subscription.moveNumber.simTypeRadioGroup,
        secretNumber: subscription.moveNumber.secretNumber.selected,
        secretInfoType: subscription.moveNumber.secretNumber.radioGroup,
        cpsCode: subscription.moveNumber.cpsCode,
        initiateNpASAP: subscription.moveNumber.initiateNpASAP
      }
    }
  })
  const panels = [
    {
      stepType: STEP_TYPE.CUSTOMER_INFO,
      heading: 'Kundeforhold',
      component: 'tlm-checkout-customer-info',
      componentDone: 'tlm-checkout-customer-type-done',
      contextName: 'customerRelation'
    },
    {
      stepType: STEP_TYPE.SUBSCRIPTION_TYPE,
      heading: 'Opsætning af abonnement',
      component: 'tlm-checkout-subscription-type',
      componentDone: 'tlm-checkout-subscription-done',
      validationComponent: 'tlm-checkout-step-validators-user-in-quarantine-validation',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CUSTOMER_INFO_CONFIRMATION,
      heading: 'Kundeoplysninger',
      component: 'tlm-checkout-customer-confirmation-type',
      componentDone: 'tlm-checkout-customer-info-done',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CONFIRMATION,
      heading: 'Opsummering',
      component: 'tlm-checkout-confirmation',
      componentDone: 'tlm-checkout-confirmation-done',
      validationComponent: 'tlm-checkout-step-validators-stock-validation',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.PAYMENT,
      heading: 'Betaling',
      component: 'payment-container',
      hasNextButton: false
    }
  ]
  let flowHandler = null;
  flowHandler = deviceAndSubscriptionFlowHandler();
  const { payment } = usePaymentInfo()
  const { confirmation } = useConfirmationInfo()
  return {
    numberInfo,
    flowHandler,
    panels,
    subscription,
    customerInfo: useCustomerInfo(appContext),
    confirmation,
    payment
  }
}
